import { orginitApi } from 'yxt-biz-pc/packages/api';

export function getDingdingCorpId(orgId = '') {
  return orginitApi.get(`dingding/corpid?orgId=${orgId}`);
}
